<template>
  <el-dialog
    title="佣金修改记录"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    append-to-body
    width="600px"
    custom-class="commission-change-record-dialog"
    @close="invalidateRequest"
    @closed="resetState"
  >
    <el-table :data="tableList.list" v-loading="loading" border style="width: 100%">
      <el-table-column label="原佣金比例" align="center" width="150">
        <template slot-scope="scope">
          {{ formatRate(scope.row.beforeCommissionRate) }}
        </template>
      </el-table-column>
      <el-table-column label="修改后佣金比例" align="center" width="170">
        <template slot-scope="scope">
          {{ formatRate(scope.row.afterCommissionRate) }}
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="修改时间" align="center" min-width="190" />
    </el-table>

    <el-pagination
      v-if="tableList.total > 0"
      class="commission-change-record__pagination"
      :current-page="params.pageNo"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next"
      :total="tableList.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </el-dialog>
</template>

<script>
import poi from '@/api/poi'

const PoiModel = new poi()

export default {
  name: 'CommissionChangeRecord',
  data() {
    return {
      dialogVisible: false,
      loading: false,
      userUUID: '',
      requestId: 0,
      params: {
        pageNo: 1,
        pageSize: 10
      },
      tableList: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
        list: []
      }
    }
  },
  methods: {
    open({ userUUID = '' } = {}) {
      this.resetState()
      if (!userUUID) {
        this.$message.error('团长UUID不能为空')
        return
      }
      this.userUUID = userUUID
      this.dialogVisible = true
      this.getList()
    },
    async getList() {
      if (!this.userUUID) return
      const requestId = ++this.requestId
      const userUUID = this.userUUID
      this.loading = true
      try {
        const res = await PoiModel.getNonCouponCommissionLogPage({
          userUUID,
          pageNo: this.params.pageNo,
          pageSize: this.params.pageSize
        })
        if (requestId !== this.requestId || userUUID !== this.userUUID) return
        if (!res || !res.data || res.data.code !== 200) {
          this.restorePagingParams()
          this.$message.error(res && res.data && res.data.message ? res.data.message : '获取佣金修改记录失败')
          return
        }
        const data = res.data.data || {}
        const list = Array.isArray(data.list) ? data.list : []
        const currentPage = data.pageNo || this.params.pageNo
        const pageSize = data.pageSize || this.params.pageSize
        this.tableList.list = list
        this.tableList.total = data.total || 0
        this.tableList.currentPage = currentPage
        this.tableList.pageSize = pageSize
        this.params.pageNo = currentPage
        this.params.pageSize = pageSize
      } catch (error) {
        if (requestId !== this.requestId || userUUID !== this.userUUID) return
        this.restorePagingParams()
        const message = error && error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : error && error.message
            ? error.message
            : '获取佣金修改记录失败'
        this.$message.error(message)
      } finally {
        if (requestId === this.requestId) {
          this.loading = false
        }
      }
    },
    formatRate(value) {
      return value == null ? '' : `${value}%`
    },
    restorePagingParams() {
      this.params.pageNo = this.tableList.currentPage
      this.params.pageSize = this.tableList.pageSize
    },
    handleSizeChange(value) {
      this.params.pageNo = 1
      this.params.pageSize = value
      this.getList()
    },
    handleCurrentChange(value) {
      this.params.pageNo = value
      this.getList()
    },
    close() {
      this.invalidateRequest()
      this.dialogVisible = false
    },
    invalidateRequest() {
      this.requestId += 1
      this.loading = false
    },
    resetState() {
      this.invalidateRequest()
      this.dialogVisible = false
      this.loading = false
      this.userUUID = ''
      this.params.pageNo = 1
      this.params.pageSize = 10
      this.tableList.currentPage = 1
      this.tableList.pageSize = 10
      this.tableList.total = 0
      this.tableList.list = []
    }
  }
}
</script>

<style scoped lang="less">
.commission-change-record {
  &__pagination {
    margin-top: 20px;
    text-align: right;
  }
}

/deep/ .commission-change-record-dialog {
  max-width: calc(100vw - 32px);
  .el-dialog__body {
    max-height: calc(100vh - 180px);
    overflow-y: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/poiCps/components/commissioSetting/commissionChangeRecord.vue